import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import 'tippy.js/themes/light.css';

tippy("[data-tippy-content]", { trigger: "click", placement: "bottom", allowHTML: true, arrow: false, theme: "light" });